// Types
import { TypeTagBase, RecipeFieldTypes } from "src/types/contentfulTypes";

// import { useRecipes } from "src/context/PinnedRecipesContext";

export const filterRecipesByPinnedOption = ({
  recipes,
  pinnedRecipeSlugs, // need to use useRecipes
  filterByTags,
  filterByPinnedRecipes,
}: {
  recipes: RecipeFieldTypes[];
  filterByTags: TypeTagBase[] | [];
  pinnedRecipeSlugs: Record<string, boolean>;
  filterByPinnedRecipes: boolean;
}) => {
  let filteredRecipes = recipes;

  // filter to pinned or non-pinned recipes, depending on the pinned property
  filteredRecipes = recipes.filter((recipe: RecipeFieldTypes) => {
    const isPinned = !!pinnedRecipeSlugs[recipe.slug];

    // If filterByPinnedRecipes is true, KEEP pinned recipes
    // If false, REMOVE pinned recipes (i.e. exclude matches)
    return filterByPinnedRecipes ? isPinned : !isPinned;
  });

  // if no filters are active, return the recipes early
  if (!filterByTags.length) return filteredRecipes;

  // Simplify filtered tag slugs to an array with just the unique tag slugs
  const filteredTagSlugs = filterByTags.map((tag) => tag.slug);

  // Filter recipes to the ones that match all the filtered tags
  return filteredRecipes.filter((recipe: any) => {
    // Simplify recipe tag slugs to an array with just the unique tag slugs
    const recipeTagSlugs = recipe.tags.map((tag: any) => tag.slug);
    // Make sure all the filtered slugs match to recipe slugs
    return filteredTagSlugs.every((slug) => {
      return recipeTagSlugs.includes(slug);
    });
  });
};
